import { render, staticRenderFns } from "./billing-setup-button.vue?vue&type=template&id=a23edb20&"
import script from "./billing-setup-button.vue?vue&type=script&lang=ts&"
export * from "./billing-setup-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports